/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { SecurityScheme } from '../../core/models/common/SecurityScheme';
import { Oas30Document } from '../../openapi/v3/models/Oas30Document';
import { Oas30SecurityScheme } from '../../openapi/v3/models/Oas30SecurityScheme';
import { NewSecuritySchemeCommand } from './NewSecuritySchemeCommand';

/**
 * @author eric.wittmann@gmail.com
 * @extends NewSecuritySchemeCommand
 * @class
 */
export class NewSecuritySchemeCommand_30 extends NewSecuritySchemeCommand {
    public _nullComponents : boolean;

    public constructor(scheme? : any) {
        if(((scheme != null && scheme instanceof <any>SecurityScheme) || scheme === null)) {
            let __args = arguments;
            super(scheme);
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._nullComponents===undefined) this._nullComponents = false;
        } else if(scheme === undefined) {
            let __args = arguments;
            super();
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._nullComponents===undefined) this._nullComponents = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewSecuritySchemeCommand] Executing.");
        let doc30 : Oas30Document = <Oas30Document>document;
        this._nullComponents = false;
        if(this.isNullOrUndefined(doc30.components)) {
            doc30.components = doc30.createComponents();
            this._nullComponents = true;
        }
        if(this.isNullOrUndefined(doc30.components.getSecurityScheme(this._schemeName))) {
            let scheme : Oas30SecurityScheme = doc30.components.createSecurityScheme(this._schemeName);
            Library.readNode(this._scheme, scheme);
            doc30.components.addSecurityScheme(this._schemeName, scheme);
            this._schemeExisted = false;
        } else {
            this._schemeExisted = true;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewSecuritySchemeCommand] Reverting.");
        if(this._schemeExisted) {
            return;
        }
        let doc30 : Oas30Document = <Oas30Document>document;
        if(this._nullComponents) {
            doc30.components = null;
            return;
        }
        doc30.components.removeSecurityScheme(this._schemeName);
    }
}
NewSecuritySchemeCommand_30["__class"] = "io.apicurio.datamodels.cmd.commands.NewSecuritySchemeCommand_30";
NewSecuritySchemeCommand_30["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




